<template>
	<div class="instructions">
		<img class="instructions__fist" src="@/assets/fist.svg" alt="fist" />
		<p class="instructions__text">
			Grab and drag <strong>right</strong> to <strong>like</strong><br />or
			<strong>left</strong> to <strong>dislike</strong>
		</p>
	</div>
</template>

<script>
export default {
	name: 'Instructions'
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';

.instructions {
	@extend %flex-center;
	@include truncate-margin;
	flex-direction: column;
	height: 9rem;
	padding-bottom: 3rem;

	&__fist {
		height: 3rem;
	}

	&__text {
		text-align: center;
		color: $white;
	}
}
</style>
